import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WalletService } from 'src/app/services/wallet.service';
import { CurrencyFacade } from 'src/app/store/currency';
import { UserFacade } from 'src/app/store/user';
import { WalletFacade } from 'src/app/store/wallet';
import { toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import isEmpty from 'src/app/lib/isEmpty';
import { encryptObject } from 'src/app/lib/cryptoJs';
import { UserService } from 'src/app/services/user.service';

function differentWalletsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const from = control.get('from')?.value;
    const to = control.get('to')?.value;

    if (from && to && from === to) {
      return { sameWallet: true };
    }
    return null;
  };
}

@Component({
  selector: 'transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css'],
})
export class TransferComponent {
  toFixedDown = toFixedDown;
  truncateDecimals = truncateDecimals;
  form: FormGroup;
  serverErrors: any = {};
  submitted = false;
  loading = false;
  currencyList: any[] = [];
  user: any = {};
  selectedCurrency: any = "INR";
  selectedCoin: any = {};
  assetData: any = {};
  bankDetails: any[] = [];
  FiatTDS: any;
  tds: number = 0;

  constructor(
    private currencyFacade: CurrencyFacade,
    private userFacade: UserFacade,
    private walletFacade: WalletFacade,
    private route: ActivatedRoute,
    private router: Router,
    private _fb: FormBuilder,
    private walletService: WalletService,
    private toastr: ToastrService,
    private userService: UserService
  ) {
    this.form = this._fb.group(
      {
        from: ["", Validators.required],
        to: ["", Validators.required],
        amount: ["", Validators.required],
      },
      { validators: differentWalletsValidator() }
    );
  }

  ngOnInit() {
    this.getUserData();
    this.route.paramMap.subscribe((params: any) => {
      if (!isEmpty(params.get('coin')))
        this.selectedCurrency = params.get('coin');
    });
    this.fetchSelectedCurrency(this.selectedCurrency);
    this.getTDSMaster();
  }

  getUserData() {
    this.userFacade.user$.subscribe({
      next: (user: any) => {
        this.user.twoFAStatus = user.twoFAStatus;
        this.user.aadharNumber =
          user.kycStatus == 'approved'
            ? 'verified'
            : 'Not verified';
      }
    });
  }

  getAssetData() {
    this.walletFacade.wallet$.subscribe({
      next: (assets: any) => {
        if (this.selectedCoin) {
          this.assetData = assets.find(
            (item: any) => item.coin == 'USDT'
          );
        }
      }
    });
  }

  getbankdetails() {
    this.userService.getbankdetails().subscribe({
      next: (v: any) => {
        this.bankDetails = v.result.bankDetails.filter(
          (element: any) => element.status == 'approved'
        );
      }
    });
  }

  fetchSelectedCurrency(currency?: string) {
    if (currency) {
      this.selectedCurrency = currency;
    } else {
      this.route.paramMap.subscribe((params: any) => {
        this.selectedCurrency = params.get('coin');
      });
    }
    this.getbankdetails();

    this.currencyFacade.currency$.subscribe({
      next: (data: any) => {
        if (data) {
          this.currencyList = data.filter(
            (item: any) => item.type === 'fiat' && item.withdrawStatus == 'active'
          );
          this.selectedCoin = this.currencyList.find(
            (el: any) => el.coin == this.selectedCurrency
          );
        }
        this.getAssetData();
      }
    });
  }

  get amount() {
    return this.form.get('amount');
  }
  get fromselect() {
    return this.form.value.from;
  }
  get toselect() {
    return this.form.value.to;
  }

  getAsset() {
    this.walletService.getAssetData().subscribe({
      next: (v: any) => {
        if (v.success) {
          this.walletFacade.setWallet(v.result);
        }
      },
      error: () => { }
    })
  }

  submitForm() {
    this.submitted = true;
    this.loading = true;
    const reqData = this.form.value;
    // Example API call
    this.walletService.assetTransfer(reqData).subscribe({
      next: (v: any) => {
        this.loading = false;
        if (v.success) {
          this.toastr.success(v.message);
          this.form.reset();
          this.serverErrors = {};
          this.getAsset()
        }
      },
      error: (err: any) => {
        this.submitted = false;
        this.loading = false;
        this.submitted = true;
        console.log('err.error.errors: ', err.error.errors);
        if (err.error.message) {
          this.toastr.error(err.error.message);
        } else if (err.error.errors) {
          const validationErrors = err.error.errors;
          this.serverErrors = validationErrors || {};
        }
      },
    });
  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
  }

  inputChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    const name = (event.target as HTMLSelectElement).name;
    this.form.patchValue({ [name]: value });
    this.serverErrors = {};
  }

  getTDSMaster() {
    this.walletService.getTDSRateForFiatWithdraw()
      .subscribe({
        next: (v: any) => {
          if (v.success) {
            this.FiatTDS = v.result;
          }
        }
      });
  }
}
